import { AxiosProgressEvent } from 'axios';
import API from 'services/api.js';
import { URL_YARD_WTS } from 'services/urls.js';

/**
 * Uploads a yard weight file to the server.
 * 
 * @param file - The file to be uploaded
 * @param filename - The name of the file
 * @param clientId - The ID of the client uploading the file
 * @param uploadProgress - Callback function to track upload progress
 * @returns A promise that resolves with the success status and message
 */
export const actionUploadYardWtFile = async (
	file: File,
	filename: string,
	clientId: number,
	sessionId: number,
	uploadProgress: (progressEvent: AxiosProgressEvent) => void
): Promise<{ success: boolean; msg: string }> => {

	// Validate client ID
	if (clientId < 1) {
		console.log('Invalid client id : ' + clientId);
		return { success: false, msg: 'Client ID not set' };
	}

	// Create FormData object to hold the file and its metadata
	const formData = new FormData();
	formData.append('file', file); // Append the file to the form data
	formData.append('filename', filename); // Append the filename

	// Configuration for the API request
	const config = {
		params: { clientId, sessionId },
		headers: { 'Content-Type': 'multipart/form-data' },
		onUploadProgress: uploadProgress, // Track upload progress
	};

	try {
		// Send POST request to upload the file
		const response = await API.post(URL_YARD_WTS, formData, config);
		console.log('response', response.data[0]);
		return response.data[0];
	} catch (error) {
		// Log any errors encountered during the upload process
		console.log('ERR actionUploadYardWtFile: ', error);
	}

	// Return failure message in case of an unknown error
	return { success: false, msg: 'Unknown error' };
};
